import { IConfigLogSettings } from '../interface/config';
import { ILogger, LOG_LEVEL } from './log.if';

const LOG_PREFIX = `log`;

let collisionCounter = 0;

const ERROR_NAME_QUOTA_EXCEEDED = [
    'QUOTA_EXCEEDED_ERR',
    'NS_ERROR_DOM_QUOTA_REACHED',
    'QuotaExceededError',
    'W3CException_DOM_QUOTA_EXCEEDED_ERR',
];

function _hasExceededQuotaError(object: unknown) {
    if (!object || typeof object !== 'object') {
        return false;
    }

    const record: Partial<Record<string, string>> = object as Partial<Record<string, string>>;

    const name = record['name'] ?? '';

    const hasQuotaError = ERROR_NAME_QUOTA_EXCEEDED.includes(name);

    return hasQuotaError;
}

function _localStorageLog(logLevel: LOG_LEVEL, message: string) {
    const time = new Date().getTime();

    const saveItem = {
        time,
        message,
        level: logLevel,
    };

    let key = [LOG_PREFIX, time].join('-');

    const willCollide = localStorage.getItem(key) !== null;

    if (willCollide) {
        collisionCounter += 1;
        key = [LOG_PREFIX, time, collisionCounter].join('-');
    } else {
        collisionCounter = 1;
    }

    try {
        localStorage.setItem(key, JSON.stringify(saveItem));
    } catch (error: unknown) {
        if (_hasExceededQuotaError(error)) {
            console.error(`Storage exceeded for LocalStorage logger: ${JSON.stringify(error)}`);
        } else {
            console.error(`LocalStorage setItem failed: ${JSON.stringify(error)}`);
        }
    }
}

function logger(levels: Array<LOG_LEVEL>, settings: IConfigLogSettings): ILogger {
    const logger: ILogger = {
        assert: (condition, message) => condition && _localStorageLog(LOG_LEVEL.ASSERT, message),
        log: (level, message) => _localStorageLog(level, message),
    };

    return logger;
}

export default logger;
